import React from 'react';
import { TableSerializerProps } from './Table.types';
import { NafCenterTableView } from './NafCenterTableView';
import { StandardTableView } from './StandardTableView';

export const TableBlock = ({ value }: TableSerializerProps) => {
  if (value.displayStyle === 'nafCenter') {
    return <NafCenterTableView value={value} />;
  }
  return <StandardTableView value={value} />;
};
